module.exports = {
    AUTH: `/vcr/web-api/v1/do-auth`,
    USER_INFO: `/vcr/web-api/v1/customer-info`,
    LOGOUT: `/vcr/web-api/v1/logout.json`,
}